<div class="checkbox-container">
  <div
    class="checkbox"
    (click)="toggle()"
    [class.checked]="control.value"
    [class.disabled]="control.disabled"
  >
    <span class="icon-container">
      @if (control.value) {
        <tds-icon name="tick" size="18px"></tds-icon>
      }
    </span>
    @if (label) {
      <span class="label-container">
        {{ label | translate }}
      </span>
    }
  </div>
</div>
